'use client';

import { EntitlementsProvider } from '@contexts/EntitlementsContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { AtomicLayoutSection } from '@coveo/atomic-react';
import { Tag } from '@lib/types/common/Tag';
import { useContext } from 'react';
import { HeadlessProductCardWrapper } from './HeadlessProductCardWrapper';
import { useResults } from './hooks/useResults';

type Props = {
  productTags?: Tag[];
  context: AtomicContext;
};

export const AtomicResultsSection = ({ productTags, context }: Props) => {
  const { searchEngine } = useContext(context);
  const { results: resultState } = useResults(searchEngine);

  return (
    <EntitlementsProvider>
      <AtomicLayoutSection data-test="search-result-section" section="results">
        {resultState?.results && resultState.results.length > 0 && (
          <ul
            data-test="search-results-list"
            className="grid grid-cols-2 justify-evenly gap-4 md:grid-cols-4 lg:grid-cols-3 lg:gap-5 lg:gap-y-2 2xl:grid-cols-4"
          >
            {resultState?.results.map((result) => (
              <li key={result.raw.ec_product_id as string}>
                <HeadlessProductCardWrapper
                  context={context}
                  result={result}
                  allProductTags={productTags}
                />
              </li>
            ))}
          </ul>
        )}
      </AtomicLayoutSection>
    </EntitlementsProvider>
  );
};
